import { useRef } from "react";
import { FaUser } from "react-icons/fa";

const ImageInput = ({
  image,
  setImage,
  previewUrl,
  setPreviewUrl,
  className,
  description = "Formato da imagem: 200x200",
  ...props
}) => {
  const fileInputRef = useRef(null);

  const handleClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setTimeout(() => {
          setPreviewUrl(reader.result);
        }, 200);
      };
      reader.readAsDataURL(file);
      setImage(file);
    }
  };

  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-center gap-4">
        {previewUrl ? (
          <img
            className="rounded-2xl shadow-md"
            src={previewUrl}
            style={{ height: "96px", width: "96px", objectFit: "cover" }}
          />
        ) : (
          <div
            className="rounded-2xl shadow-sm bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-500"
            style={{ height: "96px", width: "96px" }}
          >
            <FaUser fontSize="large" />
          </div>
        )}

        <div>
          <div className="text-sm font-semibold text-slate-700">Imagem</div>
          <small className="block mt-1 text-slate-500 text-xs">
            {description}
          </small>

          <button
            onClick={handleClick}
            className="mt-3 rounded-xl bg-emerald-600 px-3 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-emerald-700"
          >
            Escolher arquivo
          </button>
        </div>
      </div>

      <input
        type="file"
        onChange={handleImageChange}
        className="hidden"
        ref={fileInputRef}
        accept=".png, .jpg, .jpeg"
      />
    </div>
  );
};

export default ImageInput;
